export const ProductStatus = {
  AVAILABLE: 'AVAILABLE',
  UNAVAILABLE: 'UNAVAILABLE',
  REVOKED: 'REVOKED'
}

export const ProductStatusColors = {
  AVAILABLE: 'var(--success)',
  UNAVAILABLE: 'var(--danger)',
  REVOKED: 'var(--danger)'
}

export const ProductStatusListForSelect = [
  { value: ProductStatus.AVAILABLE, label: 'Disponível' },
  { value: ProductStatus.UNAVAILABLE, label: 'Indisponível' }
]

export const getProductStatusText = (status) => {
  switch (status.toUpperCase()) {
    case ProductStatus.AVAILABLE:
      return 'Disponível'
    case ProductStatus.UNAVAILABLE:
      return 'Indisponível'
    case ProductStatus.REVOKED:
      return 'Revogado'
    default:
      return 'Não definido'
  }
}
